export const CALCULATION = "CALCULATION";
export const SUMMARY_REPORT = "SUMMARY_REPORT";
export const MULTIPLE_STATE_ENTITY = "Multiple";

export const BUSY_CALCULATION_STATUS = ["QUEUED", "PROCESSING"];
